// @ts-nocheck
import { ButtonIcon } from "@insite/mobius/Button";
import buttonTypes from "@insite/mobius/Button/buttonTypes";
import { resolveColor } from "@insite/mobius/utilities";
import getContrastColor from "@insite/mobius/utilities/getContrastColor";
import { ButtonProps } from "@store/MobiusOverrides/Button/Props";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { css } from "styled-components";

type ButtonTypesProps<T extends (...args: any) => any> = Parameters<T>[0] & Pick<ButtonProps, "hoverTextColor">;

const baseButtonTypes = { ...buttonTypes };

// Sas --->
import constants from "@store/constants";
// <--- Sas

Object.assign(buttonTypes, {
    outline: (props: ButtonTypesProps<typeof buttonTypes.outline>) => {
        const mainColor = resolveColor("text", props.theme); // Sas
        const mainBorderColor = resolveColor("primary", props.theme); // Sas
        const hoverBgColor = resolveColor("secondary", props.theme);
        const hoverColor = resolveColor("common.background", props.theme);
        const disabledColor = resolveColor("common.disabled", props.theme);
        const disabledBgColor = resolveColor("common.disabledLight", props.theme);

        return css`
            border: ${pxToRem(2)} solid
                ${(props.theme as any).name === constants.themesNames.sas ? mainBorderColor : mainColor}; /* Sas */
            background: transparent;
            color: ${mainColor};

            &:not(:disabled):hover,
            &:not(:disabled):active {
                color: ${hoverColor};
                background-color: ${hoverBgColor};
                border-color: ${hoverBgColor};

                ${ButtonIcon} {
                    color: ${hoverColor};
                }
            }

            &:disabled {
                background: ${disabledBgColor};
                border-color: ${disabledBgColor};
                color: ${disabledColor};
            }
        `;
    },
});
